import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVeteran = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 15,
	height: 16,
	viewBox: "0 0 15 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M0.193882 13.8841L3.98096 9.82156L6.54014 12.5684L3.57381 15.7528C3.44791 15.8865 3.27654 15.972 3.09092 15.9938C2.90529 16.0156 2.71775 15.9722 2.56242 15.8716L0.340583 15C0.249174 14.9405 0.171969 14.8629 0.114147 14.7722C0.0563255 14.6815 0.0192234 14.5799 0.00533007 14.4742C-0.0085633 14.3685 0.00107323 14.2612 0.0335933 14.1594C0.0661133 14.0576 0.120765 13.9637 0.193882 13.8841Z",
			fill: "#4482C3"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M2.88684 7.14656C1.31643 5.46531 2.46677 3.59968 2.51524 3.52156L3.92409 1.23406C4.06026 1.01037 4.24558 0.818346 4.46694 0.671557C5.88871 -0.256568 8.69024 -0.190943 10.0054 0.671557C10.2267 0.818346 10.4121 1.01037 10.5482 1.23406L11.9603 3.53093C12.3052 4.09182 12.4556 4.74472 12.3893 5.39415C12.323 6.04358 12.0436 6.65546 11.5919 7.14031L10.4868 8.32781L7.93089 5.58718C7.93089 5.58718 9.63378 3.74343 9.74041 3.56843C9.24279 3.30593 8.44143 3.00906 7.23616 3.00906C6.03089 3.00906 5.22953 3.30593 4.73191 3.56843C4.84177 3.74031 14.2771 13.8841 14.2771 13.8841C14.3508 13.9629 14.4061 14.056 14.4393 14.1573C14.4725 14.2585 14.4829 14.3655 14.4697 14.4709C14.4566 14.5764 14.4202 14.6779 14.363 14.7685C14.3058 14.8592 14.2291 14.937 14.1382 14.9966L11.9151 15.8684C11.7601 15.9701 11.5723 16.014 11.3864 15.9922C11.2005 15.9704 11.029 15.8842 10.9037 15.7497L2.88684 7.14656Z",
			fill: "#E64C3C"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 14.4762,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgVeteran;
